<footer>
	<a href="https://www.facebook.com/Lasdumaquillage">
		<img src="/img/facebook.png" alt="https://www.facebook.com/Lasdumaquillage" />
	</a>
	<a href="https://www.instagram.com/lasdumaquillage/">
		<img src="/img/instagram.png" alt="https://www.instagram.com/lasdumaquillage/" />
	</a>
	<a href="https://www.pinterest.fr/lasdumaquillage/">
		<img src="/img/pinterest.png" alt="https://www.pinterest.fr/lasdumaquillage/" />
	</a>
</footer>

<style>
	footer {
		margin-top: 10px;
		text-align: center;
		border-width: 1px 0px 0px 0px;
		border-color: rgba(157, 138, 186);
		border-style: solid;
	}
	img {
		width: 50px;
		margin: 25px;
	}
</style>
